import { call, put } from "redux-saga/effects";
import { requestBugherdContext, requestBugherdBoards, requestSyncBugherdBoard, requestDisconnectBugherd } from "../requests/bugherd";
import { showAlert } from "../../slices/alerts";
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetBugherdContext(action) {
    try {
        const { projectId, callback } = action.payload;
        const response = yield call(requestBugherdContext, projectId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleGetBugherdBoards(action) {
    try {
        const { clientId, callback } = action.payload;
        const response = yield call(requestBugherdBoards, clientId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleSyncBugherdBoard(action) {
    try {
        const { projectId, callback } = action.payload;
        const response = yield call(requestSyncBugherdBoard, projectId);
        const { deferred = 0, failed = 0, timedOut = false } = response.data || {};
        if (deferred || failed || timedOut) {
            const parts = [];
            if (deferred) parts.push(`${deferred} not synced yet`);
            if (failed) parts.push(`${failed} failed to save`);
            if (timedOut && !deferred) parts.push('it ran out of time before reading the board');
            yield put(showAlert({ severity: 'warning', message: `Board partly synced from BugHerd — ${parts.join(', ')}` }));
        } else {
            yield put(showAlert({ severity: 'success', message: 'Board synced from BugHerd' }));
        }
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}

export function* handleDisconnectBugherd(action) {
    try {
        const { clientId, callback } = action.payload;
        const response = yield call(requestDisconnectBugherd, clientId);
        yield put(showAlert({ severity: 'success', message: 'BugHerd disconnected' }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        const { callback } = action.payload;
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) {
            callback(null);
        }
    }
}
